export const CONTACT_US_FORM_TITLE = 'How can we help?';
export const CONTACT_US_FORM_DESCRIPTION =
	"Please share what's on your mind and we will get back to you shortly.";
